var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup19285(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.683,
    height: 45.683,
    viewBox: "0 0 45.683 45.683",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19285",
    "data-name": "Group 19285",
    transform: "translate(-650.136 -428.069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16604",
    "data-name": "Group 16604",
    transform: "translate(650.136 428.069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16608",
    "data-name": "Group 16608"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 22.841,
    cy: 22.841,
    r: 22.841,
    transform: "translate(0)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13653",
    "data-name": "Path 13653",
    d: "M937.438,246.062v16.93",
    transform: "translate(-920.096 -231.687)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13654",
    "data-name": "Path 13654",
    d: "M937.438,246.062v16.93",
    transform: "translate(-910.096 -231.687)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup19285);
export default __webpack_public_path__ + "static/media/Group 19285.266f71021fc22bd83503df5d24ca83b8.svg";
export { ForwardRef as ReactComponent };